import { Component, Input, HostBinding } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'status-field',
  templateUrl: 'status-field.component.html',
  styleUrls: ['status-field.component.scss'],
})
export class StatusFieldComponent {
  @Input() changed: boolean = false;
  @Input() ghostValue: string;

  @HostBinding('class.status-field-inline')
  @Input() inline: boolean = false;

}
